import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { Shift } from '../../models/shifts/shift';
import { Service } from '../service';

@Injectable()
export class ShiftService extends Service {

    public shifts: Shift[];
    public shiftsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.shifts = [];
        this.shiftsObject = {};
    }

    public getAll(): Observable<Shift[]> {
        if (!!this.shifts && this.shifts.length > 0) {
            return Observable.create((observer: Subscriber<Shift[]>) => {
                observer.next(this.shifts);
                observer.complete();
            });
        }
        const url = 'shifts/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.shifts = r.Result;
                this.shiftsObject = this.shifts.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('relationshipsService > getAll > response', r);
            }
            return this.shifts;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/shifts/shift.service.ts